var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContacts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.82 C0,1.261 1.12,0 2.503,0 L19.497,0 C20.878,0 22,1.265 22,2.82 L22,19.18 C22,20.739 20.88,22 19.497,22 L2.503,22 C1.122,22 0,20.735 0,19.18 L0,2.82 Z M16.499,15 C16.101,15 15.6,15.361 15.475,15.737 L15.422,15.895 C15.025,17.089 13.76,18 12.501,18 L9.499,18 C8.241,18 6.975,17.088 6.578,15.895 L6.525,15.737 C6.399,15.361 5.899,15 5.501,15 L2,15 L2,19.498 C2,19.776 2.225,20 2.503,20 L19.497,20 C19.776,20 20,19.776 20,19.498 L20,15 L16.499,15 Z M20,13 L20,2.5 C20,2.226 19.773,2 19.497,2 L2.503,2 C2.224,2 2,2.223 2,2.5 L2,13 L5.501,13 C6.76,13 8.025,13.911 8.422,15.105 L8.475,15.263 C8.6,15.639 9.101,16 9.499,16 L12.501,16 C12.899,16 13.399,15.639 13.525,15.263 L13.578,15.105 C13.975,13.912 15.241,13 16.499,13 L20,13 Z M5.5,6.5 C4.948,6.5 4.5,6.052 4.5,5.5 C4.5,4.948 4.948,4.5 5.5,4.5 L16.5,4.5 C17.052,4.5 17.5,4.948 17.5,5.5 C17.5,6.052 17.052,6.5 16.5,6.5 L5.5,6.5 Z M5.5,10.5 C4.948,10.5 4.5,10.052 4.5,9.5 C4.5,8.948 4.948,8.5 5.5,8.5 L16.5,8.5 C17.052,8.5 17.5,8.948 17.5,9.5 C17.5,10.052 17.052,10.5 16.5,10.5 L5.5,10.5 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "03-Company",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icon",
    fill: "#000000",
    xlinkHref: "#path-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContacts);
export default __webpack_public_path__ + "static/media/Contacts.1d7044e1e66e412c782fe00a0b70ecb0.svg";
export { ForwardRef as ReactComponent };